import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-custom-radio-button',
    templateUrl: './custom-radio-button.component.html',
    styleUrl: './custom-radio-button.component.scss',
    standalone: false
})
export class CustomRadioButtonComponent {
  @Input() control: FormControl;
  @Input() value: any;
  @Input() name: string;
  @Input() controlId: string;
}
